import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useReplenishGridEffect({
  showReportPayment,
  myCaseResourceType,
  validatedReplenData,
  validProducts,
  reportPaymentGridData,
  countryCode,
  filteredProduct,
  replenRPGridData,
  replenGridData,
  usageDetails,
  setReplenRPGridData,
  setReplenGridData,
  dispatch,
  setShippingDetails,
  patientDetails,
  patientIdMandatory,
  getRPValidatedItemTableData,
  getValidatedItemTableData,
  getValidReplenishGridData,
  checkIfValidProductsInRecordScreen,
}) {
  useEffectWithErrorLogging(() => {
        if (!showReportPayment || myCaseResourceType === 'reportPayment') {
            if (validatedReplenData && validatedReplenData.length > 0) {
                const validatedRPItemTableData = validProducts
                    ? getRPValidatedItemTableData(
                          reportPaymentGridData,
                          validProducts,
                          countryCode
                      )
                    : reportPaymentGridData;
                const validatedItemTableData = validProducts
                    ? getValidatedItemTableData(
                          filteredProduct,
                          validProducts,
                          myCaseResourceType
                      )
                    : filteredProduct;
                const validReplenData = getValidReplenishGridData(
                    countryCode,
                    myCaseResourceType === 'reportPayment'
                        ? validatedRPItemTableData.filter(
                              (data) =>
                                  (data.isAdditionalCartEntry ||
                                      data.isAdditionalCartChild) &&
                                  data.salesOrg !== 'S030' &&
                                  !data?.cfn?.startsWith('B33')
                          )
                        : validatedItemTableData,
                    myCaseResourceType === 'reportPayment'
                        ? replenRPGridData
                        : replenGridData,
                    usageDetails.products
                        ? usageDetails?.products?.filter(
                              (item) => item.isReplenish
                          )
                        : [],
                    validatedReplenData,
                    myCaseResourceType
                );
                myCaseResourceType === 'reportPayment'
                    ? setReplenRPGridData(
                          validReplenData?.filter(
                              (data) =>
                                  (data.isAdditionalCartEntry ||
                                      data.isAdditionalCartChild) &&
                                  (countryCode === 'US'
                                      ? data.salesOrg === 'S002'
                                      : data.salesOrg !== 'S030') &&
                                  !data?.cfn?.startsWith('B33')
                          )
                      )
                    : setReplenGridData(validReplenData);
                dispatch(
                    setShippingDetails(
                        myCaseResourceType === 'reportPayment'
                            ? validReplenData?.filter(
                                  (data) =>
                                      (data.isAdditionalCartEntry ||
                                          data.isAdditionalCartChild) &&
                                      (countryCode === 'US'
                                          ? data.salesOrg === 'S002'
                                          : data.salesOrg !== 'S030') &&
                                      !data?.cfn?.startsWith('B33')
                              )
                            : validReplenData
                    )
                );
            } else if (validProducts && validProducts.length > 0) {
                const validatedItemTableData = getValidatedItemTableData(
                    filteredProduct,
                    validProducts,
                    myCaseResourceType
                );
                if (
                    checkIfValidProductsInRecordScreen(
                        validProducts,
                        validatedItemTableData,
                        patientDetails,
                        patientIdMandatory
                    )
                ) {
                    const validReplenData = getValidReplenishGridData(
                        countryCode,
                        validatedItemTableData,
                        replenGridData,
                        usageDetails.products
                            ? usageDetails?.products?.filter(
                                  (item) => item.isReplenish
                              )
                            : [],
                        []
                    );
                    setReplenGridData(validReplenData);
                    dispatch(setShippingDetails(validReplenData));
                }
            }
        }
    }, [
        validatedReplenData,
        validProducts,
        filteredProduct,
        showReportPayment,
    ]);
}